class PDPTabs {
  constructor(wrapperId) {
    this.wrapper = document.getElementById(wrapperId);
    if (!this.wrapper) return;

    this.navItems = Array.from(this.wrapper.querySelectorAll('.pdp-tabs-nav__item'));
    this.panels = Array.from(this.wrapper.querySelectorAll('.pdp-tab-panel'));

    this.bindTabs();
    this.bindStarInput();
    this.bindReviewForm();
  }

  bindTabs() {
    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        const targetId = item.getAttribute('data-tab-target');
        this.navItems.forEach((i) => i.classList.toggle('is-active', i === item));
        this.panels.forEach((p) => p.classList.toggle('is-active', p.id === targetId));
      });
    });
  }

  bindStarInput() {
    const starInput = this.wrapper.querySelector('[data-star-input]');
    if (!starInput) return;
    const stars = Array.from(starInput.querySelectorAll('button'));
    const ratingField = this.wrapper.querySelector('[data-rating-value]');

    stars.forEach((star) => {
      star.addEventListener('click', () => {
        const value = parseInt(star.getAttribute('data-star-value'), 10);
        stars.forEach((s) => {
          const sValue = parseInt(s.getAttribute('data-star-value'), 10);
          s.classList.toggle('is-selected', sValue <= value);
          s.textContent = sValue <= value ? '★' : '☆';
        });
        starInput.setAttribute('data-selected-rating', value);
        if (ratingField) ratingField.value = value;
      });
    });
  }

  bindReviewForm() {
    const form = this.wrapper.querySelector('form[id^="contact_ProductReviewForm"], .pdp-review-form form');
    if (!form) return;

    const bodyField = form.querySelector('[data-review-body-input]');
    const reviewTextInput = form.querySelector('[data-review-text-input]');
    const ratingField = form.querySelector('[data-rating-value]');
    const nameField = form.querySelector('input[name="contact[name]"]');

    form.addEventListener('submit', (e) => {
      // Require a star rating before allowing submission
      const rating = ratingField ? ratingField.value : '';
      if (!rating) {
        e.preventDefault();
        alert('Please select a star rating before submitting your review.');
        return;
      }

      // Compose the final message body sent to the store's contact notification email
      if (bodyField) {
        const productTitle = window.pdpReviewProductTitle || document.title;
        const reviewText = reviewTextInput ? reviewTextInput.value : '';
        const name = nameField ? nameField.value : '';
        bodyField.value =
          'New product review submitted\n\n' +
          'Product: ' + productTitle + '\n' +
          'Rating: ' + rating + ' / 5\n' +
          'From: ' + name + '\n\n' +
          'Review:\n' + reviewText;
      }
      // No preventDefault here — the form submits normally to Shopify's contact handler
    });
  }
}

window.PDPTabs = PDPTabs;
